import { Injectable } from '@angular/core';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { Subject } from 'rxjs';
import { PanelsService } from './panels.service';
import { RootScopeService } from './upgraded-providers/wrappers/root-scope.service';

@Injectable()
export class ShipmentsService {
  private _newShipmentCreated$ = new Subject<any>();
  shipmentCreated$ = this._newShipmentCreated$.asObservable();

  constructor(
    private _panelsService: PanelsService,
    private _rootScopeService: RootScopeService,
  ) {
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT);
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT_PANEL_CLOSE);

    this._rootScopeService.rootScopeObservable
      .subscribe(rootScope => {

        if (rootScope[ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT]) {
          this._newShipmentCreated$.next({});
          this.closeShipmentPanel();
        }

        if (rootScope[ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT_PANEL_CLOSE]) {
          this.closeShipmentPanel()
        }
      });
  }

  openNewShipmentPanel(): void {
    this._rootScopeService.updateScope(ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT_PANEL, {});
    this._panelsService.openShipmentPanel();
  }

  openShipmentDetailsPanel(shipmentData: any): void {
    this._rootScopeService.updateScope(ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT_PANEL_DETAILS, shipmentData, 0);
    this._panelsService.openShipmentPanel();
  }

  unsubscribeFromScopeChanges(){
    this._rootScopeService.unsubscribeFromScopeChanges([ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT, ROOT_SCOPE_VARIABLES.SHIPMENT.NEW_SHIPMENT_PANEL_CLOSE]);
  }

  private closeShipmentPanel(): void {
    this._panelsService.closeShipmentPanel();
  }
}
